import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { AppLoader } from "./components/utils";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
	process.env.NODE_ENV === "development" ? (
		<React.StrictMode>
			<Provider store={store}>
				<AppLoader App={App} />
			</Provider>
		</React.StrictMode>
	) : (
		<Provider store={store}>
			<AppLoader App={App} />
		</Provider>
	)
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
